import React, { useState, useEffect } from "react";
import Button from "./Button";

export default function ProgramOfferCard({
  number,
  backgroundImage,
  isOpen,
  title,
  description,
  setOpenCard,
  activeCard,
  onCardClick,
}) {
  // const toggleCard = () => {
  //   setOpen(!open);
  // };
  // useEffect(() => {
  //   if (number === 1) {
  //     setOpen(true);
  //   }
  // }, [number]);
  return (
    <>
      {" "}
      <div
        onClick={onCardClick}
        className={`h-[56px] w-full laptopSm:w-[15.92%]  laptopSm:h-[498px] rounded-[100px] px-2 laptopSm:px-0 flex gap-4 items-center laptopSm:items-end laptopSm:justify-center md:py-8 relative bg-cover bg-no-repeat bg-center cursor-pointer ${
          isOpen ? "hidden" : "block"
        }`}
        style={{
          // backgroundImage: `linear-gradient(to right, #F7AACA 0%, #F7AACA 45%, rgba(173, 119, 142, 0.70) 80%, rgba(145, 100, 119, 0.30) 100%), url(${backgroundImage})`,
          backgroundImage: window.matchMedia("(min-width: 1024px)").matches
            ? `linear-gradient(to top, #F7AACA 0%, #F7AACA 45%, rgba(173, 119, 142, 0.70) 80%, rgba(145, 100, 119, 0.30) 100%), url(${backgroundImage})`
            : `linear-gradient(to right, #F7AACA 0%, #F7AACA 45%, rgba(173, 119, 142, 0.70) 80%, rgba(145, 100, 119, 0.30) 100%), url(${backgroundImage})`,
        }}
      >
        <div className="rounded-full bg-primary-normal w-10 h-10 laptopSm:w-[112px] laptopSm:h-[112px] flex items-center justify-center">
          <span className="font-montserrat font-bold text-[25px] laptopSm:text-[50px] text-secondary-normal">
            {number}
          </span>
        </div>
        {/* <h1 className="font-bold text-base text-secondary-light tracking-widest">
  Elementary
</h1> */}
      </div>
      <div
        className={`w-full laptopSm:h-[498px] laptopSm:flex-1 flex flex-col gap-4 laptopSm:gap-6 px-4 py-6 md:px-[60px] md:py-[60px] rounded-[50px] bg-primary-light cursor-pointer
            ${
              isOpen
                ? "block transition duration-500 ease-linear translate-x-1"
                : "hidden"
            }`}
      >
        <p className="font-montserrat font-semibold text-lg md:text-[32px] text-text-normal capitalize leading-none">
          {title}
        </p>
        <p className=" font-notoSans font-light text-xs md:text-sm leading-6 tracking-[0.06em] ">
          {description}
        </p>
        <div className="flex items-center justify-center laptopSm:mt-auto">
          <Button text={"Button"} type={"outline"} navigateTo={"/"} />
        </div>
      </div>
      {/* {isOpen && (
        <div
          // onClick={onCardClick}
          className={`w-full laptopSm:h-[498px] laptopSm:flex-1 flex flex-col gap-4 laptopSm:gap-6 px-4 py-6 md:px-[60px] md:py-[60px] rounded-[50px] bg-primary-light cursor-pointer
            ${isOpen ? "" : ""}`}
        >
          <p className="font-montserrat font-semibold text-lg md:text-[32px] text-text-normal capitalize leading-none">
            {title}
          </p>
          <p className=" font-notoSans font-light text-xs md:text-sm leading-6 tracking-[0.06em] ">
            {description}
          </p>
          <div className="flex items-center justify-center laptopSm:mt-auto">
            <Button text={"Button"} type={"outline"} navigateTo={"/"} />
          </div>
        </div>
      )} */}
    </>
  );
}

// Define prop types for the component
// ProgramOfferCard.propTypes = {
//   id: PropTypes.number.isRequired,
//   number: PropTypes.number.isRequired,
//   backgroundImage: PropTypes.string,
//   isOpen: PropTypes.bool.isRequired,
//   onCardClick: PropTypes.func.isRequired,
// };
